<template>
    <v-dialog v-model="display" fullscreen>
        <v-card class="fill-height">
            <v-row no-gutters>
                <v-col cols="10" class="content">
                    <v-row class="py-4 px-8" v-if="view === 'punches'">
                        <v-col cols="6">
                            <v-card
                                color="#74bcbd"
                                style="color: white; height: 95vh"
                                class="clocked-in easy-read-text"
                            >
                                <h1 class="ma-2">
                                    Clocked In
                                    <v-divider />
                                </h1>
                                <div
                                    class="d-flex flex-column flex-wrap fill-height"
                                >
                                    <span v-if="loadingEmployees">
                                        <v-progress-circular
                                            color="blue-lighten-3"
                                            indeterminate
                                            :size="120"
                                            class="mt-4"
                                        />
                                    </span>
                                    <span
                                        v-else
                                        class="text-h5 ma-1"
                                        v-for="emp in activeEmployees"
                                    >
                                        {{ emp.Fname + " " + emp.Lname }}
                                    </span>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card
                                color="#c7405d"
                                style="height: 95vh"
                                class="not-clocked-in easy-read-text"
                            >
                                <h1 class="ma-2">
                                    Not Clocked In
                                    <v-divider />
                                </h1>
                                <div
                                    class="d-flex flex-column flex-wrap fill-height"
                                >
                                    <span v-if="loadingEmployees">
                                        <v-progress-circular
                                            color="blue-lighten-3"
                                            indeterminate
                                            :size="120"
                                            class="mt-4"
                                        />
                                    </span>
                                    <span
                                        v-else
                                        class="text-h5 ma-1"
                                        v-for="emp in inactiveEmployees"
                                    >
                                        {{ emp.Fname + " " + emp.Lname }}
                                    </span>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row
                        no-gutters
                        class="py-4 px-8"
                        v-if="view === 'project'"
                    >
                        <v-col cols="12" class="text-center">
                            <span class="text-h4 easy-read-text">
                                {{ this.displayProject.project_number }}
                            </span>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-center text-h3 easy-read-text"
                        >
                            <span class="text-h3 easy-read-text">
                                {{ this.displayProject.project_name }}
                            </span>
                            <v-divider color="white" class="mb-2" />
                        </v-col>

                        <v-col cols="5">
                            <div class="process-list-container">
                                <v-card
                                    class="d-flex justify-space-between text-h5 mb-2 pa-2"
                                    v-for="process in processes"
                                >
                                    <v-row>
                                        <v-col cols="6">
                                            <b>{{ process.ProcessName }}</b>
                                        </v-col>
                                        <v-col cols="6">
                                            <div class="d-flex flex-column">
                                                <div
                                                    v-for="employee in this.getEmployeesByProcess(
                                                        process
                                                    )"
                                                >
                                                    {{ employee }}
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </v-col>
                        <v-col cols="7">
                            <div style="max-height: 85vh; overflow-y: auto">
                                <v-row no-gutters class="px-4">
                                    <v-col cols="12" class="mb-2">
                                        <v-card>
                                            <div class="text-h5 mx-2">
                                                Current Processes
                                            </div>
                                            <div
                                                id="pieChart"
                                                class="d-flex justify-center"
                                            />
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <div class="text-h5 mx-2">
                                                Daily Job Count
                                            </div>
                                            <div
                                                v-if="
                                                    loadingLineChart &&
                                                    !this.lineChart
                                                "
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-progress-circular
                                                    color="blue-lighten-3"
                                                    indeterminate
                                                    :size="120"
                                                    class="my-4"
                                                />
                                            </div>
                                            <div
                                                id="lineChart"
                                                class="d-flex justify-center"
                                            ></div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2" class="scroll-list">
                    <div
                        class="project-list-container"
                        ref="projectListContainer"
                    >
                        <div v-if="loadingProjects">
                            <v-progress-circular
                                color="blue-lighten-3"
                                indeterminate
                                :size="120"
                                class="mt-4"
                            />
                        </div>
                        <div
                            v-else
                            v-for="project in projectArray"
                            class="mb-2"
                        >
                            <v-progress-circular
                                bg-color="grey"
                                color="blue"
                                :size="200"
                                :width="12"
                                :model-value="getProgressVal(project)"
                                style="width: 100%"
                            >
                                <div style="width: 50%">
                                    {{ truncateString(project.project_name) }}
                                </div>
                                <div class="ma-2 text-h5">
                                    {{ getProgressVal(project) }}%
                                </div>
                            </v-progress-circular>
                            <div
                                v-if="project.count > 0"
                                class="d-flex justify-center"
                            >
                                <span v-for="employee in project.count">
                                    <v-icon
                                        color="white"
                                        size="x-large"
                                        icon="mdi:mdi-account"
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ApexCharts from "apexcharts";
import GuestLayout from "../../Layouts/GuestLayout.vue";

export default {
    layout: [GuestLayout],
    name: "GlobalPunch-TV",
    components: {},
    emits: [],
    props: {},
    watch: {},
    data() {
        return {
            company: null,
            display: true,
            activeEmployees: [],
            inactiveEmployees: [],
            dataArray: [],
            projectArray: [],
            projectPunches: [],
            processes: [],
            displayProject: null,
            loadingEmployees: false,
            loadingProjects: false,
            loadingLineChart: false,
            view: "punches",
            pieChart: null,
            lineChart: null,
            scrollTimeout: null,
            detailsTimeout: null,
            pageRefreshTimeout: null,
            screenSize: {
                x: window.innerWidth,
                y: window.innerHeight,
            },
        };
    },
    created() {
        const lastDashIndex = window.location.href.lastIndexOf("-");
        if (lastDashIndex !== -1) {
            this.company = window.location.href.substring(lastDashIndex + 1);
        }

        window.addEventListener("resize", this.updateScreenSize);
        this.getProcesses();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateScreenSize);
    },
    mounted() {
        this.showPunches();
        this.getProjects();
    },
    beforeUnmount() {
        if (this.pieChart && this.lineChart) {
            this.pieChart.destroy();
            this.lineChart.destroy();
        }
    },
    computed: {},
    methods: {
        async getProcesses() {
            try {
                await axios
                    .get(
                        route("api.globalPunchSystem.getAllProcesses", {
                            company: this.company,
                        })
                    )
                    .then((response) => {
                        this.processes = response.data;
                        this.processes.sort((a, b) =>
                            a.ProcessName.localeCompare(b.ProcessName)
                        );
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getEmployees() {
            this.loadingEmployees = true;
            this.activeEmployees = [];
            this.inactiveEmployees = [];

            try {
                await axios
                    .get(
                        route("api.globalPunchSystem.getTVCurrentWorkers", {
                            company: this.company,
                        })
                    )
                    .then((response) => {
                        this.activeEmployees = response.data.active;
                        this.inactiveEmployees = response.data.inactive;
                    });
            } catch (err) {
                console.log(err);
            }
            this.loadingEmployees = false;
        },
        async getProjects() {
            this.loadingProjects = true;
            try {
                await axios
                    .get(
                        route("api.globalPunchSystem.getTVLaborEntries", {
                            company: this.company,
                        })
                    )
                    .then((response) => {
                        this.projectArray = [];
                        this.dataArray = [];
                        this.dataArray = response.data.data;

                        let projectCounts = {};
                        this.dataArray.forEach((item) => {
                            if (projectCounts[item.project_id]) {
                                projectCounts[item.project_id].count++;
                            } else {
                                projectCounts[item.project_id] = {
                                    project_id: item.project_id,
                                    project_name: item.project_name,
                                    project_number: item.project_number,
                                    count: 1,
                                };
                            }
                        });
                        this.projectArray = Object.values(projectCounts);
                        this.loadingProjects = false;
                        this.startAutoScroll(); // SCROLLING ANIMATIONS START HERE
                    });
            } catch (err) {
                console.log(err);
            }
        },
        truncateString(text) {
            // Split the string into an array of words
            const words = text.replace("	", " ").split(" ");

            let segments = [];
            let currentSegment = "";
            let segmentLength = 0;
            let count = 0;

            while (words.length > 0 && count < 3) {
                let word = words.shift();

                if (currentSegment.length + word.length + 1 <= 15) {
                    // Add the word to the current segment
                    currentSegment +=
                        (currentSegment.length > 0 ? " " : "") + word;
                } else {
                    // Add the current segment to the segments array
                    segments.push(currentSegment);
                    // Reset current segment and length
                    currentSegment = word;
                    segmentLength = word.length;
                    count++;
                }
            }

            // Add the last segment if not empty
            if (currentSegment.length > 0 && count < 3) {
                segments.push(currentSegment);
            }

            return segments.join(" ");
        },
        getProgressVal(project) {
            return Math.round((project.count / this.dataArray.length) * 100);
        },
        getEmployeesByProcess(process) {
            let employees = [];
            this.dataArray.forEach((item) => {
                if (
                    item.process_id === process.ID &&
                    item.project_id === this.displayProject.project_id
                ) {
                    employees.push(item.employee_name);
                }
            });
            return employees;
        },
        showPunches() {
            this.getEmployees();
            this.view = "punches";
            if (this.lineChart) {
                this.lineChart.destroy();
                this.lineChart = null;
            }
            if (this.pieChart) {
                this.pieChart.destroy();
                this.pieChart = null;
            }
        },
        showProjectDetails(project) {
            this.displayProject = project;
            this.view = "project";
            this.$nextTick(() => {
                this.createPieChart();
                this.createLineChart();
            });
        },
        createPieChart() {
            let processes = [];
            let processCounts = [];
            let processMap = new Map();

            this.dataArray.forEach((item) => {
                if (item.project_id === this.displayProject.project_id) {
                    if (processMap.has(item.process_id)) {
                        // Increment the count of the existing process
                        let index = processMap.get(item.process_id);
                        processCounts[index]++;
                    } else {
                        // Add the new process and initialize its count to 1
                        processes.push(item.process_name);
                        processCounts.push(1);
                        processMap.set(item.process_id, processes.length - 1);
                    }
                }
            });

            if (processes.length == 0 && processCounts.length == 0) {
                processes.push("No current processes");
                processCounts.push(1);
            }

            let colorMap = {
                Acrylic: "#F44336",
                Assembly: "#E91E63",
                "Assembly Metal": "#9C27B0",
                Carpentary: "#3F51B5",
                CNC: "#2196F3",
                Cutting: "#00bcd4", // teal
                Electricity: "#FFEB3B",
                Engineering: "#009688",
                "Final Assembly": "#4CAF50",
                Maintenance: "#CDDC39",
                MetalShop: "#607D8B", // grey
                Packaging: "#FF5722", // deep orange
                Painting: "#FF9800",
                "Pre-Assembly Wood": "#795548",
                Printing: "#FFC107", // amber
                Stock: "#607D8B",
                Upholstery: "#673AB7",
                Welding: "#00BCD4",
            };
            let colors = processes.map(
                (process) => colorMap[process] || this.getRandomColor() // "#000000"
            );
            let height = this.screenSize.y * 0.35;

            var options = {
                series: processCounts,
                chart: {
                    height: height,
                    type: "pie",
                },
                labels: processes,
                colors: colors,
            };

            if (this.pieChart) {
                // If the chart already exists, update it
                this.pieChart.updateOptions({
                    labels: processes,
                    colors: colors,
                });
                this.pieChart.updateSeries(processCounts);
            } else {
                // If the chart doesn't exist, create it
                var chart = new ApexCharts(
                    document.querySelector("#pieChart"),
                    options
                );
                this.pieChart = chart;
                this.pieChart.render();
            }
        },
        async createLineChart() {
            this.loadingLineChart = true;
            try {
                await axios
                    .get(
                        route("api.globalPunchSystem.getTVLaborWeek", {
                            company: this.company,
                            project_id: this.displayProject.project_id,
                        })
                    )
                    .then((response) => {
                        this.projectPunches = response.data;
                    });
            } catch (err) {
                console.log(err);
            }

            const displayValues = Object.values(this.projectPunches);
            const displayDates = Object.keys(this.projectPunches);

            let height = this.screenSize.y * 0.35;

            var options = {
                series: [
                    {
                        name: "Total",
                        data: displayValues,
                    },
                ],
                chart: {
                    height: height,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "smooth",
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: displayDates,
                },
            };

            if (this.lineChart) {
                // If the chart already exists, update it
                this.lineChart.updateOptions({
                    xaxis: {
                        categories: displayDates,
                    },
                });
                this.lineChart.updateSeries([
                    {
                        name: "Total",
                        data: displayValues,
                    },
                ]);
            } else {
                // If the chart doesn't exist, create it
                var chart = new ApexCharts(
                    document.querySelector("#lineChart"),
                    options
                );
                this.lineChart = chart;
                this.lineChart.render();
            }

            this.loadingLineChart = false;
        },
        startAutoScroll() {
            const container = this.$refs.projectListContainer;
            const scrollDuration = 8000 * this.projectArray.length; // Total scroll time
            const scrollStep = 1; // Scroll speed
            const pauseDuration = 3000; // Delay at start and end of scroll animation

            // Clear any existing timeouts to avoid multiple calls
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout);
            }
            if (this.detailsTimeout) {
                clearTimeout(this.detailsTimeout);
            }
            if (this.pageRefreshTimeout) {
                clearTimeout(this.pageRefreshTimeout);
            }

            // Function to scroll the project list
            const scroll = () => {
                container.scrollTop += scrollStep;

                if (
                    container.scrollTop + container.clientHeight >=
                    container.scrollHeight
                ) {
                    // Pause at the bottom before scrolling back to the top
                    this.scrollTimeout = setTimeout(() => {
                        container.scrollTop = 0;
                        this.scrollTimeout = setTimeout(scroll, pauseDuration);
                    }, pauseDuration);
                } else {
                    this.scrollTimeout = setTimeout(
                        scroll,
                        scrollDuration / container.scrollHeight
                    );
                }
            };

            scroll();

            // Function to show project details sequentially with delay
            const showDetails = (index = 0) => {
                if (this.projectArray.length > 0) {
                    if (index >= this.projectArray.length) {
                        // If we reach the end of the array, show punches and then restart the process
                        this.showPunches();
                        this.detailsTimeout = setTimeout(() => {
                            index = 0; // Reset the index
                            showDetails(index); // Restart the process after showing punches
                        }, 15000); // Delay of 15 seconds before restarting
                        return;
                    }

                    this.showProjectDetails(this.projectArray[index]);

                    this.detailsTimeout = setTimeout(() => {
                        showDetails(index + 1);
                    }, 15000); // Delay of 15 seconds
                }
            };

            // Initial delay before starting the showDetails function
            this.detailsTimeout = setTimeout(() => {
                showDetails();
            }, 15000); // Initial delay of 15 seconds

            // Call getProjects after 1 hour (3,600,000 milliseconds)
            this.pageRefreshTimeout = setTimeout(() => {
                location.reload();
            }, 3600000);
        },

        getRandomColor() {
            var letters = "0123456789ABCDEF";
            var color = "#";
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        updateScreenSize() {
            this.screenSize = {
                x: window.innerWidth,
                y: window.innerHeight,
            };
        },
    },
};
</script>
<style scoped>
.content {
    background-color: rgb(34, 102, 68); /* #212121; */
}

.scroll-list {
    background-color: black;
    overflow-y: auto;
}
.not-clocked-in {
    background-image: url("/images/GlobalPunch/exclamation-thick.svg");
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
}
.clocked-in {
    background-image: url("/images/GlobalPunch/clock-outline.svg");
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
}
.easy-read-text {
    text-align: center;
    color: white;
    text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
        1px 1px 0 black;
}
:deep(.v-progress-circular__content) {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    color: white;
    text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
        1px 1px 0 black;
}
.project-list-container {
    max-height: 100vh;
    overflow-y: auto;
    text-align: center;
    padding: 12px;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer/Edge */
}
.project-list-container::-webkit-scrollbar {
    display: none; /* Webkit (Chrome, Safari) */
}
.process-list-container {
    max-height: 82vh;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer/Edge */
}
.process-list-container::-webkit-scrollbar {
    display: none; /* Webkit (Chrome, Safari) */
}
</style>
